export default {"src":"/_next/static/media/empty-favorite-dark.fd6b2d44.svg","height":100,"width":100};